import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { InputDatePicker } from "jalaali-react-date-picker";


import * as Template from "../../templates";
import * as actions from "../../actions";

import moment from "moment-jalaali";
import { useNavigate, useParams } from "react-router-dom";

export default (props) => {
  const moduleName = `vouchers`;
  const { match } = props;
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();


  const params = useParams()
  const navigate = useNavigate()

  const [id, setId] = useState();
  const [type, setType] = useState(``);
  const [name, setName] = useState(``);
  const [amount, setAmount] = useState(``);
  const [hash, setHash] = useState(``);

  const [expireAt, setExpireAt] = useState(moment());
  const [startAt, setStartAt] = useState(moment());

  const [minimumInvoiceTotal, setMinimumInvoiceTotal] = useState(``);
  const [maximumInvoiceTotal, setMaximumInvoiceTotal] = useState(``);
  const [counts, setCounts] = useState(``);
  const [freeShipping, setFreeShipping] = useState(``);

  const [brands, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);

  const [brandId, setBrandId] = useState();
  const [categoryId, setCategoryId] = useState();

  const [submitted, setSubmitted] = useState(false);

  const [state, setState] = useState(``);

  const handleChangeState = value => setState(value);
  
  const handleChangeType = (value) => setType(value);
  
  const handleChangeFreeShipping = (value) => setFreeShipping(value);

  const handleChangeBrand = (value) => setBrandId(value);

  const handleChangeCategory = (value) => setCategoryId(value);

  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true)
  };

  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.vouchers_store != undefined && appReducer.vouchers_store.error == false) ||
        (appReducer.vouchers_update != undefined && appReducer.vouchers_update.error == false)
      ) {
        navigate(-1)
      }
    }
    return () => setSubmitted(false)
  }, [
    appReducer.vouchers_store,
    appReducer.vouchers_update
  ])

  useEffect(() => {
    if (appReducer.vouchers_edit != undefined && id != undefined) {
      let row = appReducer.vouchers_edit.data;
      setName(row.name);
      setHash(row.hash);
      setAmount(row.amount);
      setCounts(row.counts);
      setMinimumInvoiceTotal(row.minimum_invoice_total);
      setMaximumInvoiceTotal(row.maximum_invoice_total);

      if(row.categories != null){

        let categoryItems = []

        row.categories.map( cat => {
          categoryItems.push({
            label: cat.category.name,
            value: cat.category_id
          })
        })

        setCategoryId(categoryItems)

      }

      if(row.brands != null){

        let brandItems = []

        row.brands.map( brand => {
          brandItems.push({
            label: brand.brand.name,
            value: brand.brand_id
          })
        })

        setBrandId(brandItems)

      }

      setType({
        value: row.type,
        label: row.type == `percent` ? `درصدی` : `مبلغی`,
      });
      setFreeShipping({
        value: row.free_shipping,
        label: row.free_shipping == `active` ? `فعال` : `غیرفعال`,
      });
      setState({
        value: row.state,
        label: row.state == `active` ? `فعال` : `غیرفعال`,
      });
      setExpireAt(moment(row.expire_at_timestamp));
      setStartAt(moment(row.start_at_timestamp));

    }
  }, [appReducer.vouchers_edit]);


  useEffect(() => {
    if(appReducer.brands_option_list != null){
      setBrands(appReducer.brands_option_list.data)
    }
    if(appReducer.product_categories_option_list){
      setCategories(appReducer.product_categories_option_list.data)
    }
  }, [appReducer])

  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
  }, [id]);

  useEffect(() => {
    dispatch(actions.list(`brands/option`));
    dispatch(actions.list(`product_categories/option`));
  }, [])

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])

  return <Template.Form>

    <Template.Input value={name} required label="نام تخفیف" name="name" type="text" />

    <Template.Input value={hash} required label="کد تخفیف" name="hash" type="text" />

    <Template.SingleSelect
      onChange={handleChangeCategory}
      placeholder="دسته‌بندی"
      multi={true}
      withLabel={true}
      name="categories[]"
      value={categoryId}
      options={categories}
    />

    <Template.SingleSelect
      onChange={handleChangeBrand}
      placeholder="برند‌ها"
      multi={true}
      withLabel={true}
      value={brandId}
      name="brands[]"
      options={brands}
    />

    <Template.SingleSelect
      onChange={handleChangeType}
      placeholder="نوع"
      withLabel={true}
      name="type"
      required
      value={type}
      options={[
        {
          value: "percent",
          label: "درصدی",
        },
        {
          value: "price",
          label: "مبلغی",
        },
      ]}
    />

    <Template.Input required value={amount} label="مقدار" name="amount" type="text" />

    <fieldset>
      <label className="text-gray-500">تاریخ شروع <i className="star">*</i></label>
      <InputDatePicker onChange={(e) => setStartAt(e)} defaultValue={startAt} />
      <input
        type="hidden"
        name="start_at"
        defaultValue={startAt.format("YYYY-MM-DD")}
      />
    </fieldset>

    <fieldset>
      <label className="text-gray-500">تاریخ اعتبار <i className="star ">*</i></label>
      <InputDatePicker onChange={(e) => setExpireAt(e)} defaultValue={expireAt} />
      <input
        type="hidden"
        name="expire_at"
        defaultValue={expireAt.format("YYYY-MM-DD")}
      />
    </fieldset>

    <Template.Input value={counts} label="تعداد تخفیف" name="counts" type="text" />

    <Template.Input value={minimumInvoiceTotal} label="حداقل مقدار سفارش (ریال)" name="minimum_invoice_total" type="text" />

    <Template.Input value={maximumInvoiceTotal} label="حداکثر مقدار سفارش (ریال)" name="maximum_invoice_total" type="text" />

    <Template.SingleSelect
      withLabel
      required
      placeholder="وضعیت"
      onChange={handleChangeState}
      name="state"
      value={state}
      options={[
        {
          value: "active",
          label: "فعال",
        },
        {
          value: "deactive",
          label: "غیرفعال",
        },
      ]}
    />

    <Template.SingleSelect
      withLabel
      required
      placeholder="هزینه حمل رایگان"
      onChange={handleChangeFreeShipping}
      name="free_shipping"
      value={freeShipping}
      options={[
        {
          value: "active",
          label: "فعال",
        },
        {
          value: "deactive",
          label: "غیرفعال",
        },
      ]}
    />

    <Template.Button
      label="ذخیره"
      onClick={handleClick}
    />
  </Template.Form>
};
